import React from "react";
import styled from "styled-components";

const Svg = styled.svg`
	display: block;
	width: 100%;
	height: auto;
	max-height: 200px;
`;

const wrap = (children) => <Svg viewBox="0 0 400 220" xmlns="http://www.w3.org/2000/svg" role="img" focusable="false">{children}</Svg>;

/** Decorative illustrations for each platform strip step (vector “images”). */
export default function PlatformLayerArt({ layerKey, title }) {
	const commonTitle = <title>{title}</title>;

	switch (layerKey) {
		case "intelligence":
			return wrap(
				<>
					{commonTitle}
					<defs>
						<linearGradient id="pla-intel" x1="0%" y1="0%" x2="100%" y2="100%">
							<stop offset="0%" stopColor="#0077cc" stopOpacity="0.35" />
							<stop offset="100%" stopColor="#ffc400" stopOpacity="0.2" />
						</linearGradient>
					</defs>
					<rect x="20" y="20" width="360" height="180" rx="14" fill="#0e1317" stroke="#2a3440" strokeWidth="1.5" />
					<rect x="36" y="40" width="120" height="72" rx="8" fill="url(#pla-intel)" stroke="#0077cc" strokeWidth="1" opacity="0.9" />
					<circle cx="92" cy="76" r="18" fill="none" stroke="#6f839f" strokeWidth="2" />
					<path d="M 86 76 L 90 80 L 100 68" fill="none" stroke="#00875a" strokeWidth="2.5" strokeLinecap="round" />
					<rect x="172" y="44" width="192" height="10" rx="3" fill="#191e22" />
					<rect x="172" y="62" width="160" height="10" rx="3" fill="#191e22" />
					<rect x="172" y="80" width="176" height="10" rx="3" fill="#191e22" />
					<path d="M 48 138 Q 120 118 200 128 T 352 124" fill="none" stroke="#0077cc" strokeWidth="2" strokeDasharray="4 4" opacity="0.7" />
					<circle cx="200" cy="128" r="8" fill="#0077cc" opacity="0.85" />
					<circle cx="280" cy="122" r="6" fill="#ffc400" opacity="0.7" />
					<text x="200" y="188" textAnchor="middle" fill="#6f839f" fontSize="13" fontFamily="system-ui, sans-serif" fontWeight="600">
						strategy · narrative · knowledge
					</text>
				</>
			);
		case "dashboard":
			return wrap(
				<>
					{commonTitle}
					<rect x="20" y="24" width="360" height="172" rx="12" fill="#0e1317" stroke="#2a3440" strokeWidth="1.5" />
					<rect x="36" y="40" width="200" height="100" rx="8" fill="#191e22" stroke="#0077cc" strokeWidth="1" />
					<rect x="48" y="52" width="56" height="28" rx="4" fill="#0077cc" opacity="0.45" />
					<rect x="112" y="52" width="56" height="28" rx="4" fill="#0077cc" opacity="0.25" />
					<rect x="176" y="52" width="48" height="28" rx="4" fill="#0077cc" opacity="0.35" />
					<path d="M 52 108 L 72 88 L 96 96 L 124 72 L 156 84 L 188 64 L 216 76" fill="none" stroke="#ffc400" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
					<rect x="248" y="40" width="116" height="140" rx="8" fill="#191e22" stroke="#586d8e" strokeWidth="1" />
					<line x1="260" y1="58" x2="340" y2="58" stroke="#586d8e" strokeWidth="6" strokeLinecap="round" />
					<line x1="260" y1="78" x2="320" y2="78" stroke="#586d8e" strokeWidth="6" strokeLinecap="round" />
					<line x1="260" y1="98" x2="332" y2="98" stroke="#586d8e" strokeWidth="6" strokeLinecap="round" />
					<text x="200" y="200" textAnchor="middle" fill="#6f839f" fontSize="13" fontFamily="system-ui, sans-serif" fontWeight="600">
						maps · timelines · saved filters
					</text>
				</>
			);
		case "api":
			return wrap(
				<>
					{commonTitle}
					<rect x="20" y="28" width="360" height="164" rx="12" fill="#0e1317" stroke="#2a3440" strokeWidth="1.5" />
					<text x="60" y="95" fill="#0077cc" fontSize="42" fontFamily="Consolas, monospace" fontWeight="700">
						{"</>"}
					</text>
					<rect x="140" y="52" width="220" height="36" rx="6" fill="#191e22" stroke="#0077cc" strokeWidth="1" />
					<text x="154" y="75" fill="#c5d4e0" fontSize="11" fontFamily="Consolas, monospace">
						POST /product/search
					</text>
					<rect x="140" y="100" width="100" height="28" rx="5" fill="rgba(0,119,204,0.2)" stroke="#0077cc" strokeWidth="0.8" />
					<text x="190" y="118" textAnchor="middle" fill="#edf2f6" fontSize="10" fontFamily="system-ui, sans-serif">
						SDK
					</text>
					<rect x="252" y="100" width="108" height="28" rx="5" fill="rgba(155,108,252,0.15)" stroke="#9b6cfc" strokeWidth="0.8" />
					<text x="306" y="118" textAnchor="middle" fill="#edf2f6" fontSize="9" fontFamily="system-ui, sans-serif">
						vector
					</text>
					<path d="M 40 150 H 360" stroke="#586d8e" strokeWidth="1" strokeDasharray="3 5" opacity="0.6" />
					<text x="200" y="182" textAnchor="middle" fill="#6f839f" fontSize="13" fontFamily="system-ui, sans-serif" fontWeight="600">
						REST · TypeScript · smart search
					</text>
				</>
			);
		case "agent":
			return wrap(
				<>
					{commonTitle}
					<rect x="20" y="28" width="360" height="164" rx="12" fill="#0e1317" stroke="#2a3440" strokeWidth="1.5" />
					<rect x="48" y="56" width="88" height="72" rx="10" fill="rgba(0,119,204,0.2)" stroke="#0077cc" strokeWidth="1.5" />
					<text x="92" y="98" textAnchor="middle" fill="#edf2f6" fontSize="12" fontFamily="system-ui, sans-serif" fontWeight="700">
						agent
					</text>
					<path d="M 144 92 H 175" stroke="#ffc400" strokeWidth="2.5" strokeLinecap="round" />
					<polygon points="175,92 168,86 168,98" fill="#ffc400" />
					<rect x="188" y="64" width="180" height="56" rx="8" fill="#191e22" stroke="#586d8e" strokeWidth="1" />
					<text x="278" y="88" textAnchor="middle" fill="#6f839f" fontSize="10" fontFamily="system-ui, sans-serif">
						cron · IOC · metadata · reports
					</text>
					<text x="278" y="106" textAnchor="middle" fill="#6f839f" fontSize="9" fontFamily="system-ui, sans-serif">
						pull from API → format → deliver
					</text>
					<text x="200" y="182" textAnchor="middle" fill="#6f839f" fontSize="13" fontFamily="system-ui, sans-serif" fontWeight="600">
						scheduled delivery at the edge
					</text>
				</>
			);
		case "destinations":
			return wrap(
				<>
					{commonTitle}
					<rect x="20" y="28" width="360" height="164" rx="12" fill="#0e1317" stroke="#2a3440" strokeWidth="1.5" />
					<circle cx="200" cy="88" r="22" fill="rgba(0,119,204,0.25)" stroke="#0077cc" strokeWidth="2" />
					<text x="200" y="94" textAnchor="middle" fill="#edf2f6" fontSize="11" fontFamily="system-ui, sans-serif" fontWeight="600">
						out
					</text>
					<line x1="200" y1="110" x2="200" y2="128" stroke="#586d8e" strokeWidth="2" />
					<line x1="200" y1="128" x2="96" y2="158" stroke="#586d8e" strokeWidth="1.5" />
					<line x1="200" y1="128" x2="200" y2="168" stroke="#586d8e" strokeWidth="1.5" />
					<line x1="200" y1="128" x2="304" y2="158" stroke="#586d8e" strokeWidth="1.5" />
					<rect x="56" y="158" width="72" height="26" rx="6" fill="#191e22" stroke="#6f839f" strokeWidth="1" />
					<text x="92" y="175" textAnchor="middle" fill="#c5d4e0" fontSize="9" fontFamily="system-ui, sans-serif">
						chat
					</text>
					<rect x="164" y="158" width="72" height="26" rx="6" fill="#191e22" stroke="#6f839f" strokeWidth="1" />
					<text x="200" y="175" textAnchor="middle" fill="#c5d4e0" fontSize="9" fontFamily="system-ui, sans-serif">
						SIEM
					</text>
					<rect x="272" y="158" width="72" height="26" rx="6" fill="#191e22" stroke="#6f839f" strokeWidth="1" />
					<text x="308" y="175" textAnchor="middle" fill="#c5d4e0" fontSize="9" fontFamily="system-ui, sans-serif">
						EDR
					</text>
					<text x="200" y="208" textAnchor="middle" fill="#6f839f" fontSize="12" fontFamily="system-ui, sans-serif" fontWeight="600">
						into the tools you already use
					</text>
				</>
			);
		default:
			return wrap(
				<>
					<title>{title || "Platform layer"}</title>
					<rect x="40" y="40" width="320" height="140" rx="12" fill="#191e22" stroke="#586d8e" strokeWidth="1" />
				</>
			);
	}
}
